import styled from 'styled-components'
import { Columns } from 'components/flex'
import { H2, H4 } from 'components/typography/heading'
import { Grid } from 'components/grid'

export const Hero = styled.div`
    margin-bottom: 24px;
`

export const Heading = styled(H2)`
    margin-bottom: 8px;
`

export const Status = styled(Grid)`
    grid-auto-flow: column;
    grid-auto-columns: auto;
    column-gap: 16px;
    justify-content: start;
    align-items: center;

    margin-bottom: 8px;
`

export const Deadline = styled(Grid)`
    grid-auto-flow: column;
    grid-auto-columns: auto;
    column-gap: 8px;
    justify-content: start;
    align-items: center;
    margin-top: 4px;
`

export const Signatories = styled.div`
    margin-bottom: 24px;

    &.compact {
        margin: 0;
    }
`

export const Subheading = styled(H4)`
    margin-bottom: 8px;
`

export const SubheadingColumns = styled(Columns)`
    align-items: center;
    column-gap: 8px;
    margin-bottom: 8px;

    ${Subheading} {
        margin: 0;
    }
`